/**
 * The participant's Logiscool account, as the team reads it (08.10.2026):
 * can they sign in, who disabled the account if somebody did, and whether
 * the password is still the one Logiscool generated. Never the password.
 */
const REASONS = { cancelled: "înscriere anulată", refunded: "plată rambursată", deleted: "înscriere ștearsă" };

const day = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("ro-RO");
};

/** `{tone, text}` for the account line — tone is ok, off, warn or unknown. */
export function accountLine(account, fmt = day) {
  if (!account) return null;
  if (account.ok === false) return { tone: "unknown", text: "Nu am putut citi starea contului de la Logiscool." };
  if (!account.found) return { tone: "warn", text: "Logiscool nu găsește acest cursant în lista lui." };
  if (account.enabled === true) return { tone: "ok", text: "Cont activ: poate intra în MyLogiscool." };
  if (account.enabled === false) {
    const ours = account.disabled_by_us;
    if (ours) {
      const why = REASONS[ours.reason] || ours.reason;
      return { tone: "off", text: `Cont dezactivat de noi la retragere, pe ${fmt(ours.at)}${why ? ` (${why})` : ""}.` };
    }
    return { tone: "off", text: "Cont dezactivat la Logiscool, nu de noi. Poate fi blocat după încercări greșite." };
  }
  return { tone: "unknown", text: "Logiscool nu spune dacă contul e activ." };
}

/** The password, in words — or null when unknown. */
export function passwordLine(account) {
  if (!account?.found || account.password_known === null || account.password_known === undefined) return null;
  return account.password_known
    ? "Parola e cea generată de Logiscool: se poate vedea și retrimite."
    : "Parola a fost schimbată de cursant: nu se mai poate vedea; resetează-o dacă a uitat-o.";
}

/** Somebody who withdrew, whose enrolment is paid again: the team decides. */
export function cameBack(account) {
  return Boolean(account?.enabled === false && account.disabled_by_us && !account.withdrawn);
}

/** What the reactivation box offers, given the account and the licences left. */
export function reactivationChoices(account, { groupName, free } = {}) {
  const removed = Boolean(account?.disabled_by_us?.removed_from_group);
  const left = typeof free === "number" ? free : null;
  return {
    withdrawnWarning: account?.withdrawn
      ? "Persoana s-a retras: înscrierea e anulată sau rambursată. Îi dai totuși acces la Logiscool?" : null,
    canReadd: removed && left !== 0,
    readdLabel: removed ? (groupName ? `Reactivează și adaugă în „${groupName}”` : "Reactivează și adaugă înapoi în grupă") : null,
    readdNote: removed
      ? (left === 0 ? "Nu mai e nicio licență liberă: îl poți doar reactiva."
        : `Readăugarea consumă o licență${left !== null ? ` (rămân ${Math.max(0, left - 1)})` : ""}.`)
      : null,
  };
}
